import { createReducer } from 'typesafe-actions';
import { validateSharedLocalStorage } from '../../../helpers/validateLocalStorage';
import { _updateCompanyVendor } from '../../actions/shared';

export interface SharedReducer {
  companyVendor: string | null;
}

const localStorageData = validateSharedLocalStorage();

const initialState: SharedReducer = {
  companyVendor: null,
  ...localStorageData,
};

export const sharedReducer = createReducer<SharedReducer>(
  initialState,
).handleAction(
  _updateCompanyVendor,
  (
    state: SharedReducer,
    action: ReturnType<typeof _updateCompanyVendor>,
  ): SharedReducer => ({
    ...state,
    companyVendor: action.payload,
  }),
);
